import { ScheduledEvent } from '@/types/Api/ScheduledEvent';

import {
  performPostToBackend,
  performPutToBackend,
  performDeleteToBackend,
} from '@/flagler-api/backend-api';

export async function createEvent(
  event: ScheduledEvent
): Promise<ScheduledEvent> {
  const result = await performPostToBackend('/event/create', event);
  return result.data;
}

export async function updateEvent(
  event: ScheduledEvent
): Promise<ScheduledEvent> {
  const result = await performPutToBackend('/event/update', event);
  return result.data;
}

export async function deleteEvent(eventId: string): Promise<void> {
  await performDeleteToBackend(`/event/${eventId}`);
}

export async function getEvents(
  from: Date,
  to?: Date,
  userIds?: string[]
): Promise<ScheduledEvent[]> {
  const response = await performPostToBackend('/event/user/search', {
    fromTime: from.getTime(),
    toTime: to ? to.getTime() : undefined,
    forHumans: true,
    userIds,
  });
  return response.data;
}
